import { EllipsedText, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo } from 'react';
import { ListChildComponentProps } from 'react-window';
import { Skill } from '../../../types/jobs';

function SkillItem({
  data,
  index,
  style,
}: Readonly<
  ListChildComponentProps<{
    skills: Skill[];
    type: 'selectable' | 'deselectable';
    onClick: (skill: Skill) => void;
    isLoaded?: (index: number) => boolean;
  }>
>) {
  const skill = data.skills[index];

  return (
    <span style={style as CSSProperties}>
      <ListItem
        endEnhancer={() => (
          <Button
            size="mini"
            shape="round"
            kind="tertiary"
            onClick={() => data.onClick(skill)}
          >
            <MaterialIcon
              name={data.type === 'selectable' ? 'add' : 'remove'}
              size="mini"
            />
          </Button>
        )}
      >
        <ListItemLabel>
          <EllipsedText>{skill?.name || '-'}</EllipsedText>
        </ListItemLabel>
      </ListItem>
    </span>
  );
}

export default memo(SkillItem);
